import Icon from '../components/Icon.vue'

Icon.register({
  gift: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M32 448v-128h192v160h-160c-17.7 0-32-14.3-32-32zM288 480v-160h192v128c0 17.7-14.3 32-32 32h-160zM480 160c17.7 0 32 14.3 32 32v80c0 8.8-7.2 16-16 16h-480c-8.8 0-16-7.2-16-16v-80c0-17.7 14.3-32 32-32h44.1c-6.3-12.1-10.1-25.5-10.1-40 0-48.5 39.5-88 88-88 41.6 0 68.5 21.3 103 68.3 34.5-47 61.4-68.3 103-68.3 48.5 0 88 39.5 88 88 0 14.5-3.9 27.9-10.1 40h42.1zM153.9 160h86.1c-51.5-76.7-66.2-80-86.1-80-22.1 0-40 17.9-40 40s17.9 40 40 40zM360 160c22.1 0 40-17.9 40-40s-17.9-40-40-40c-20.4 0-34.7 3.5-86.1 80h86.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/gift.js
// module id = 1381
// module chunks = 0